import React from 'react';
import { isNotEmptyArray } from 'src/services/validationService';
import RCPagination from 'src/components/common/RCPagination';
import PayrollTable from './PayrollTable';

const PayrollTableWithPagination = ({
    payrollData,
    isFetching,
    mode = 'LIST',
    onPageChange,
    onDetail,
    onEdit,
    onDelete,
    onSelect,
    onAssociate,
    selectedItems,
    associatedItems,
    filters,
    onFilterChange,
    onClearFilters,
    onApplyFilters
}) => {
    const hasRecords = isNotEmptyArray(payrollData?.records);
    const page = payrollData?.metadata?.page + 1;
    const totalItems = payrollData?.metadata?.filteredCount;
    const perPage = payrollData?.metadata?.pageSize;

    return (
        <>
            <PayrollTable
                records={payrollData?.records}
                isFetching={isFetching}
                mode={mode}
                onDetail={onDetail}
                onEdit={onEdit}
                onDelete={onDelete}
                onSelect={onSelect}
                onAssociate={onAssociate}
                selectedItems={selectedItems}
                associatedItems={associatedItems}
                filters={filters}
                onFilterChange={onFilterChange}
                onClearFilters={onClearFilters}
                onApplyFilters={onApplyFilters}
            />
            {hasRecords && (
                <RCPagination
                    activePage={page}
                    itemsCountPerPage={perPage}
                    totalItemsCount={totalItems}
                    totalItems={totalItems}
                    thePage={page}
                    onChange={onPageChange}
                    innerClass="justify-content-center"
                />
            )}
        </>
    );
};

export default PayrollTableWithPagination;